(function bootGrovaCartDrawer() {
  document.documentElement.dataset.grovaCartScriptLoaded = 'true';
  const root = document.querySelector('[data-grova-cart]');
  if (!root) {
    if (!window.__grovaCartBootTimer) {
      window.__grovaCartBootTimer = window.setInterval(() => {
        if (!document.querySelector('[data-grova-cart]')) return;
        window.clearInterval(window.__grovaCartBootTimer);
        window.__grovaCartBootTimer = null;
        bootGrovaCartDrawer();
      }, 50);
    }
    return;
  }
  if (root.dataset.grovaCartInitialized === 'true') return;
  root.dataset.grovaCartInitialized = 'true';
  try {
  const body = root.querySelector('[data-grova-cart-body]');
  const footer = root.querySelector('[data-grova-cart-footer]');
  const countEl = root.querySelector('[data-grova-cart-count]');
  const note = root.querySelector('[data-grova-cart-subscription-note]');
  const shippingText = root.querySelector('[data-grova-cart-shipping-text]');
  const shippingProgress = root.querySelector('[data-grova-cart-shipping-progress]');
  const totalEl = root.querySelector('[data-grova-cart-total]');
  const checkoutTotalEl = root.querySelector('[data-grova-cart-checkout-total]');
  const originalTotalEl = root.querySelector('[data-grova-cart-original-total]');
  const shippingSummary = root.querySelector('[data-grova-cart-shipping-summary]');
  const savingsEl = root.querySelector('[data-grova-cart-savings]');
  const savingsBanner = root.querySelector('[data-grova-cart-savings-banner]');
  const discountRow = root.querySelector('[data-grova-cart-discount-row]');
  const discountLabel = root.querySelector('[data-grova-cart-discount-label]');
  const discountCodesEl = root.querySelector('[data-grova-cart-discount-codes]');
  const initialJson = root.querySelector('[data-grova-cart-json]');
  const emptyUrl = root.dataset.emptyUrl || '/collections/all';
  const currentCurrency = root.dataset.currency || window.Shopify?.currency?.active || document.documentElement.dataset.currency || 'EUR';
  const giftCardImages = {
    '1000': root.dataset.giftCardImage10 || '',
    '2000': root.dataset.giftCardImage20 || '',
  };
  const logoUrl = 'https://cdn.shopify.com/s/files/1/0889/9808/4942/files/grova_1.png?v=1747000939';
  const bundleProducts = new Map([
    ['10890084286798', { supply: '6 Month Supply', giftCardCents: 1000 }],
    ['10890082877774', { supply: '12 Month Supply', giftCardCents: 2000 }],
  ]);
  const subscriptionOptions = [
    {
      key: '1',
      label: '1 Month',
      cartLabel: '1 Month Supply Every Month',
      discount: '20% OFF',
      variantId: 52836461510990,
      sellingPlanId: 689548165454,
    },
    {
      key: '2',
      label: '2 Month',
      cartLabel: '2 Month Supply Every 2 Months',
      discount: '30% OFF',
      variantId: 52836461543758,
      sellingPlanId: 689561043278,
    },
    {
      key: '3',
      label: '3 Month',
      cartLabel: '3 Month Supply Every 3 Months',
      discount: '40% OFF',
      variantId: 52836461576526,
      sellingPlanId: 689561076046,
    },
  ];
  const subscriptionOptionsByVariant = new Map(subscriptionOptions.map((option) => [String(option.variantId), option]));
  const subscriptionOptionsByPlan = new Map(subscriptionOptions.map((option) => [String(option.sellingPlanId), option]));
  const streamlinedThreeMonthOption = {
    ...subscriptionOptions.find((option) => option.key === '3'),
    variantId: 60100253811022,
    sellingPlanId: 692769620302,
  };
  const streamlinedThreeMonthCompareAtCents = currentCurrency === 'GBP' ? 10700 : 12000;
  const editableSubscriptionOptions = subscriptionOptions
    .filter((option) => option.key !== '2')
    .map((option) => (option.key === '3' ? streamlinedThreeMonthOption : option));
  subscriptionOptionsByVariant.set(String(streamlinedThreeMonthOption.variantId), streamlinedThreeMonthOption);
  subscriptionOptionsByPlan.set(String(streamlinedThreeMonthOption.sellingPlanId), streamlinedThreeMonthOption);
  const subscriptionGifts = {
    journal: {
      variantId: 60193621213518,
      title: 'Wellness Journal',
      pluralTitle: 'Wellness Journals',
      valueCents: currentCurrency === 'GBP' ? 900 : 1000,
      image: 'https://cdn.shopify.com/s/files/1/0889/9808/4942/files/image_79_33920635-6af7-45c2-bde2-0f39fe07e700.webp?v=1784737230',
    },
    canister: {
      variantId: 60193613775182,
      title: 'Gummy Canister',
      pluralTitle: 'Gummy Canisters',
      valueCents: currentCurrency === 'GBP' ? 1300 : 1500,
      image: 'https://cdn.shopify.com/s/files/1/0889/9808/4942/files/image_80.webp?v=1784737219',
    },
  };
  const legacySubscriptionGiftVariantIds = new Set(['60237094420814', '60237099729230']);
  const subscriptionGiftVariantIds = new Set(
    [...Object.values(subscriptionGifts).map((gift) => String(gift.variantId)), ...legacySubscriptionGiftVariantIds]
  );
  const removedSubscriptionGiftsAttribute = '_grova_removed_subscription_gifts';
  const removedSubscriptionGiftsVersionAttribute = '_grova_removed_subscription_gifts_version';
  const removedSubscriptionGiftsVersion = '2';
  let cart = parseInitialCart();
  let refreshPromise = null;
  let giftSyncPromise = null;
  let updatingLine = null;
  let updatingPlanKey = null;
  let closeTimer = null;
  let touchStartY = 0;
  let pageScrollLock = null;
  let preparedUnlockTimer = null;
  const productCache = new Map();
  const moneyFormatters = new Map();
  const hydrationPromises = new WeakMap();

  function parseInitialCart() {
    try {
      return JSON.parse(initialJson?.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function currencyCode() {
    return currentCurrency;
  }

  function formatMoney(cents) {
    const value = (Number(cents) || 0) / 100;
    const fractionDigits = value % 1 === 0 ? 0 : 2;
    const key = `${currencyCode()}-${fractionDigits}`;
    if (!moneyFormatters.has(key)) {
      moneyFormatters.set(
        key,
        new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode(),
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: 2,
        })
      );
    }
    return moneyFormatters.get(key).format(value);
  }

  function formatCurrencyValue(value) {
    const amount = Number(value) || 0;
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode(),
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isOptiMonkEvent(event) {
    return event.composedPath().some((node) => {
      if (!(node instanceof Element)) return false;
      const identity = `${node.id} ${node.className} ${node.getAttribute('src') || ''}`.toLowerCase();
      return identity.includes('optimonk') || identity.includes('om-holder-campaign-');
    });
  }

  function logoMarkup() {
    return `
      <img
        class="grova-cart__mark"
        src="${logoUrl}"
        alt="Grova"
        width="609"
        height="223"
        loading="eager"
        decoding="async"
      >
    `;
  }

  function hasSubscriptionItems() {
    return Array.isArray(cart.items) && cart.items.some((item) => item.selling_plan_allocation);
  }

  function hasFreeShippingItems() {
    return hasSubscriptionItems() || (
      Array.isArray(cart.items) && cart.items.some((item) => bundleProducts.has(String(item.product_id)))
    );
  }

  function itemOriginalLinePrice(item) {
    const isStreamlinedThreeMonth =
      String(item.variant_id) === String(streamlinedThreeMonthOption.variantId) ||
      String(item.selling_plan_allocation?.selling_plan?.id) === String(streamlinedThreeMonthOption.sellingPlanId);
    if (isStreamlinedThreeMonth) {
      return streamlinedThreeMonthCompareAtCents * item.quantity;
    }

    const compareAt = item.variant?.compare_at_price || item.compare_at_price || item._variant_compare_at_price;
    if (compareAt && compareAt > item.original_price) {
      return compareAt * item.quantity;
    }

    return item.original_line_price || item.original_price * item.quantity;
  }

  function itemFinalLinePrice(item) {
    return item.final_line_price ?? item.line_price ?? item.price * item.quantity;
  }

  function itemCodeDiscountTotal(item) {
    return (item.line_level_discount_allocations || []).reduce((total, allocation) => {
      return allocation.discount_application?.type === 'discount_code' ? total + (Number(allocation.amount) || 0) : total;
    }, 0);
  }

  function itemDisplayedLinePrice(item) {
    return itemFinalLinePrice(item) + itemCodeDiscountTotal(item);
  }

  function cartOriginalTotal() {
    return (cart.items || []).reduce((sum, item) => {
      return isSubscriptionGift(item) ? sum : sum + itemOriginalLinePrice(item);
    }, 0);
  }

  function appliedCodeDiscounts(cartData) {
    const applications = [
      ...(cartData.cart_level_discount_applications || []),
      ...(cartData.items || []).flatMap((item) =>
        (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application).filter(Boolean)
      ),
    ];

    return applications
      .filter((application) => application.type === 'discount_code')
      .filter(
        (application, index, entries) =>
          entries.findIndex((entry) => (entry.title || entry.code) === (application.title || application.code)) === index
      );
  }

  function discountValueText(application) {
    if (application.value_type === 'percentage') return `${Number(application.value) || 0}% Off`;
    if (application.value_type === 'fixed_amount') return `${formatCurrencyValue(application.value)} Off`;
    return '';
  }

  function renderDiscountCodes() {
    if (!discountRow || !discountCodesEl || !discountLabel) return;

    const discounts = appliedCodeDiscounts(cart);
    const values = [...new Set(discounts.map(discountValueText).filter(Boolean))];
    discountRow.hidden = !discounts.length;
    discountLabel.textContent = values.length ? `Discount (${values.join(', ')})` : 'Discount';
    discountCodesEl.innerHTML = discounts
      .map(
        (discount) => `
          <span class="grova-cart__discount-pill">
            <span>${escapeHtml(discount.title || discount.code)}</span>
            <button
              type="button"
              aria-label="Remove discount code ${escapeHtml(discount.title || discount.code)}"
              data-grova-cart-remove-discount="${escapeHtml(discount.title || discount.code)}"
            >&times;</button>
          </span>
        `
      )
      .join('');
  }

  function variantText(item) {
    const bundle = bundleProducts.get(String(item.product_id));
    if (bundle) return bundle.supply;

    if (item.variant_title && item.variant_title !== 'Default Title') return item.variant_title;
    if (Array.isArray(item.options_with_values) && item.options_with_values.length) {
      return item.options_with_values.map((option) => option.value).join(', ');
    }
    return '';
  }

  function sellingPlanText(item) {
    return item.selling_plan_allocation?.selling_plan?.name || '';
  }

  function deliveryText(item) {
    return sellingPlanText(item).replace(/^Deliver every/i, 'Delivered every') || 'Delivered once';
  }

  function itemTitle(item) {
    return bundleProducts.has(String(item.product_id)) ? 'Total Wellness Mushroom Gummies' : item.product_title;
  }

  function bundleGiftMarkup(item) {
    const bundle = bundleProducts.get(String(item.product_id));
    if (!bundle) return '';

    const giftCardValue = formatMoney(bundle.giftCardCents);
    const giftCardImage = giftCardImages[String(bundle.giftCardCents)];
    const image = giftCardImage
      ? `<img src="${escapeHtml(giftCardImage)}" alt="${escapeHtml(giftCardValue)} gift card" loading="lazy">`
      : `<span class="grova-cart__bundle-gift-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M20 12v9H4v-9m-2-5h20v5H2V7Zm10 14V7m0 0H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7Zm0 0h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>
        </span>`;

    return `
      <div class="grova-cart__bundle-gift">
        ${image}
        <span><strong>Free ${escapeHtml(giftCardValue)} Gift Card</strong><small>Included with your bundle</small></span>
      </div>
    `;
  }

  function updateShippingProgress(count) {
    const hasFreeShipping = hasFreeShippingItems();

    note.hidden = !count;
    if (!count) return;

    shippingText.textContent = hasFreeShipping
      ? 'You have unlocked free shipping!'
      : 'Upgrade to subscription to unlock free shipping.';
    shippingProgress.style.width = hasFreeShipping ? '100%' : '42%';
    note.classList.toggle('is-unlocked', hasFreeShipping);
  }

  function productHandleForItem(item) {
    if (item.handle) return item.handle;
    const url = item.url || item.product_url || '';
    return url.split('/products/')[1]?.split(/[/?#]/)[0] || '';
  }

  async function productDataForHandle(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);

    const productPromise = fetch(`/products/${handle}.js`, {
      credentials: 'same-origin',
      cache: 'force-cache',
    })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);

    productCache.set(handle, productPromise);
    return productPromise;
  }

  function hydrateVariantCompareAtPrices(cartData) {
    if (hydrationPromises.has(cartData)) return hydrationPromises.get(cartData);

    const hydrationPromise = (async () => {
      const items = cartData.items || [];
      let changed = false;
      await Promise.all(
        items.map(async (item) => {
          if (item._variant_compare_at_price || item.variant?.compare_at_price || item.compare_at_price) return;

          const productData = await productDataForHandle(productHandleForItem(item));
          const variant = productData?.variants?.find((entry) => Number(entry.id) === Number(item.variant_id));
          if (variant?.compare_at_price) {
            item._variant_compare_at_price = Number(variant.compare_at_price);
            changed = true;
          }
        })
      );
      return changed;
    })();

    hydrationPromises.set(cartData, hydrationPromise);
    return hydrationPromise;
  }

  function hydrateAndRender(cartData) {
    hydrateVariantCompareAtPrices(cartData).then((changed) => {
      if (changed && cart === cartData) render();
    });
  }

  function subscriptionOptionForItem(item) {
    if (!item) return null;

    const planId = item.selling_plan_allocation?.selling_plan?.id;
    return subscriptionOptionsByPlan.get(String(planId)) || subscriptionOptionsByVariant.get(String(item.variant_id));
  }

  function isSubscriptionItem(item) {
    return Boolean(item.selling_plan_allocation);
  }

  function subscriptionControlsMarkup(item, index) {
    const currentOption = subscriptionOptionForItem(item);
    if (!currentOption) return '';

    const isUpdating = updatingLine === index + 1;
    const loadingMarkup = isUpdating
      ? '<span class="grova-cart__loading" aria-hidden="true"></span><span class="visually-hidden">Updating cart</span>'
      : '';

    if (!isSubscriptionItem(item)) {
      const giftBenefit =
        currentOption.key === '3'
          ? `2 FREE gifts worth ${formatMoney(subscriptionGifts.journal.valueCents + subscriptionGifts.canister.valueCents)} included`
          : currentOption.key === '2'
            ? `1 FREE gift worth ${formatMoney(subscriptionGifts.journal.valueCents)} included`
            : '';
      const giftBenefitMarkup = giftBenefit
        ? `
            <li>
              <span aria-hidden="true">
                <svg viewBox="0 0 24 24"><path d="M4 8h16v12H4V8Zm-2-4h20v4H2V4Zm10 16V4m0 4H8.5a2.5 2.5 0 1 1 0-5C11 3 12 8 12 8Zm0 0h3.5a2.5 2.5 0 1 0 0-5C13 3 12 8 12 8Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>
              </span>
              ${giftBenefit}
            </li>
          `
        : '';

      return `
        <div class="grova-cart__subscription grova-cart__subscription--upgrade ${isUpdating ? 'is-loading' : ''}" data-subscription-controls aria-busy="${isUpdating ? 'true' : 'false'}">
          <span class="grova-cart__upgrade-badge">Most Popular</span>
          <h3 class="grova-cart__upgrade-title">Subscribe &amp; Save ${currentOption.discount.replace(' OFF', '')}</h3>
          <ul class="grova-cart__upgrade-benefits">
            <li>
              <span aria-hidden="true">
                <svg viewBox="0 0 24 24"><path d="M4 5h10l6 6-9 9-7-7V5Z" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="9" cy="10" r="1.4" fill="currentColor"/></svg>
              </span>
              Save ${escapeHtml(currentOption.discount.replace(' OFF', ''))} on this ${escapeHtml(currentOption.label.toLowerCase())} supply
            </li>
            ${giftBenefitMarkup}
            <li>
              <span aria-hidden="true">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M9.5 8.5v7M14.5 8.5v7" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
              </span>
              No commitment, modify or cancel any time
            </li>
            <li>
              <span aria-hidden="true">
                <svg viewBox="0 0 24 24"><path d="M3 6h11v10H3V6Zm11 4h3.5l3.5 3.5V16h-7v-6Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="7" cy="18" r="1.8" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="18" cy="18" r="1.8" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>
              </span>
              Free shipping on every order
            </li>
            <li>
              <span aria-hidden="true">
                <svg viewBox="0 0 24 24"><path d="M12 3.5 19 6v5.7c0 4.2-2.8 7.5-7 8.8-4.2-1.3-7-4.6-7-8.8V6l7-2.5Z" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="m8.5 12 2.2 2.2 4.8-5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>
              </span>
              Love it or get a full refund
            </li>
          </ul>
          <button class="grova-cart__subscribe-button" type="button" data-grova-cart-subscribe="${index + 1}" ${isUpdating ? 'disabled' : ''}>
            ${loadingMarkup}
            <span>Upgrade &amp; Save</span>
          </button>
        </div>
      `;
    }

    const optionButtons = editableSubscriptionOptions
      .map((option) => {
        const isActive = currentOption.key === option.key;
        const isChosenPlan = updatingPlanKey === option.key;
        const statusMarkup =
          isUpdating && isChosenPlan
            ? '<span class="grova-cart__loading grova-cart__plan-loader" aria-hidden="true"></span><span class="visually-hidden">Updating cart</span>'
            : '';

        return `
          <button
            class="grova-cart__plan ${isActive ? 'is-active' : ''}"
            type="button"
            data-grova-cart-plan="${option.key}"
            aria-pressed="${isActive ? 'true' : 'false'}"
            ${isUpdating ? 'disabled' : ''}
          >
            <span class="grova-cart__plan-radio" aria-hidden="true"></span>
              <span class="grova-cart__plan-copy">
              <span class="grova-cart__plan-title">${option.cartLabel}</span>
            </span>
            ${statusMarkup}
          </button>
        `;
      })
      .join('');

    return `
      <div class="grova-cart__subscription" data-subscription-controls>
        <div class="grova-cart__subscription-top">
          <span>Subscribe &amp; Save</span>
          <button
            class="grova-cart__toggle is-on"
            type="button"
            role="switch"
            aria-checked="true"
            data-grova-cart-one-time="${index + 1}"
            ${isUpdating ? 'disabled' : ''}
          >
            <span></span>
          </button>
        </div>
        <div class="grova-cart__plans ${isUpdating ? 'is-loading' : ''}" aria-busy="${isUpdating ? 'true' : 'false'}">
          ${optionButtons}
        </div>
        <div class="grova-cart__commitment">
          <span class="grova-cart__commitment-icon" aria-hidden="true">
            <svg viewBox="0 0 256 256" focusable="false">
              <path d="M128 24a104 104 0 1 0 104 104A104.1 104.1 0 0 0 128 24Zm0 192a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88ZM112 96v64a8 8 0 0 1-16 0V96a8 8 0 0 1 16 0Zm48 0v64a8 8 0 0 1-16 0V96a8 8 0 0 1 16 0Z" fill="currentColor"/>
            </svg>
          </span>
          <span>No commitment, modify or cancel any time.</span>
        </div>
      </div>
    `;
  }

  function isSubscriptionGift(item) {
    return subscriptionGiftVariantIds.has(String(item?.variant_id));
  }

  function supplySelectorMarkup(item, index) {
    const currentOption = subscriptionOptionForItem(item);
    if (!currentOption) return '';

    const subscribed = isSubscriptionItem(item);
    const isUpdating = updatingLine === index + 1;
    const subscriptionRows = editableSubscriptionOptions
      .map((option) => {
        const isActive = subscribed && currentOption.key === option.key;
        return `
          <button
            class="grova-cart__supply-option ${isActive ? 'is-active' : ''}"
            type="button"
            data-grova-cart-plan="${option.key}"
            aria-pressed="${isActive ? 'true' : 'false'}"
            ${isUpdating ? 'disabled' : ''}
          >
            <span class="grova-cart__supply-radio" aria-hidden="true"></span>
            <span class="grova-cart__supply-copy">
              <strong>${option.label} Supply</strong>
              <small>Delivered every ${option.key === '1' ? 'month' : `${option.key} months`}</small>
            </span>
          </button>
        `;
      })
      .join('');

    return `
      <details
        class="grova-cart__supply-select ${isUpdating ? 'is-loading' : ''}"
        data-subscription-controls
        aria-busy="${isUpdating ? 'true' : 'false'}"
      >
        <summary aria-label="Change supply">
          <strong>${isUpdating ? 'Updating Supply…' : 'Change Supply'}</strong>
          ${
            isUpdating
              ? '<span class="grova-cart__loading grova-cart__supply-loader" aria-hidden="true"></span><span class="visually-hidden" aria-live="polite">Updating supply</span>'
              : '<span class="grova-cart__supply-chevron" aria-hidden="true"></span>'
          }
        </summary>
        <div class="grova-cart__supply-menu" aria-busy="${isUpdating ? 'true' : 'false'}">
          ${subscriptionRows}
        </div>
      </details>
    `;
  }

  function subscriptionGiftsMarkup(item) {
    if (!isSubscriptionItem(item)) return '';
    const option = subscriptionOptionForItem(item);
    const eligibleGiftKeys = option?.key === '3' ? ['journal', 'canister'] : option?.key === '2' ? ['journal'] : [];
    const removedVariantIds = removedSubscriptionGiftVariantIds(cart);
    const giftItems = eligibleGiftKeys
      .map((key) => ({
        key,
        item: (cart.items || []).find(
          (cartItem) => String(cartItem.variant_id) === String(subscriptionGifts[key].variantId)
        ),
      }));
    if (!giftItems.length) return '';

    return `
      <div class="grova-cart__free-gifts">
        <h3>Free Gifts Included In Your Order:</h3>
        ${giftItems
          .map(({ key, item: giftItem }) => {
            const gift = subscriptionGifts[key];
            const isRemoved = removedVariantIds.has(String(gift.variantId));
            const giftQuantity = Math.max(1, Number(giftItem?.quantity) || Number(item.quantity) || 1);
            const giftTitle = giftQuantity === 1 ? gift.title : gift.pluralTitle;
            return `
              <div class="grova-cart__free-gift ${isRemoved ? 'is-removed' : ''}">
                <img src="${escapeHtml(gift.image)}" alt="" loading="lazy">
                <span class="grova-cart__free-gift-title">${giftQuantity} ${escapeHtml(giftTitle)}</span>
                <span class="grova-cart__free-gift-price"><s>${formatMoney(gift.valueCents)}</s><strong>${
                  isRemoved ? 'REMOVED' : 'FREE'
                }</strong></span>
                <button
                  class="grova-cart__free-gift-remove"
                  type="button"
                  aria-label="${isRemoved ? 'Add back' : 'Remove'} free ${escapeHtml(gift.title)}"
                  title="${isRemoved ? 'Add gift back' : 'Remove gift'}"
                  data-grova-cart-toggle-gift="${gift.variantId}"
                  data-grova-cart-gift-removed="${isRemoved ? 'true' : 'false'}"
                >${isRemoved ? '+' : '&times;'}</button>
              </div>
            `;
          })
          .join('')}
      </div>
    `;
  }

  function renderEmpty() {
    if (body.querySelector('.grova-cart__empty')) return;

    body.innerHTML = `
      <div class="grova-cart__empty">
        <div class="grova-cart__empty-inner">
          ${logoMarkup()}
          <p>Your cart is empty.</p>
          <a class="grova-cart__empty-button" href="${escapeHtml(emptyUrl)}">GET STARTED</a>
        </div>
      </div>
    `;
  }

  function renderPendingAdd() {
    root.classList.add('is-pending-add');
    note.hidden = true;
    footer.hidden = true;
    body.innerHTML = `
      <div class="grova-cart__pending" aria-live="polite" aria-busy="true">
        <div class="grova-cart__pending-image"></div>
        <div class="grova-cart__pending-copy">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    `;
  }

  function renderItems() {
    const visibleItems = (cart.items || [])
      .map((item, index) => ({ item, index }))
      .filter(({ item }) => !isSubscriptionGift(item));

    body.innerHTML = visibleItems
      .map(({ item, index }) => {
        const original = itemOriginalLinePrice(item);
        const displayedFinal = itemDisplayedLinePrice(item);
        const savings = Math.max(original - displayedFinal, 0);
        const variant = variantText(item);
        const sellingPlan = deliveryText(item);
        const title = itemTitle(item);
        const image = item.image
          ? `<img class="grova-cart__image" src="${escapeHtml(item.image)}" alt="${escapeHtml(title)}" loading="lazy">`
          : logoMarkup();

        return `
          <article class="grova-cart__item" data-line="${index + 1}">
            <a class="grova-cart__image-link" href="${escapeHtml(item.url)}">${image}</a>
            <a class="grova-cart__item-title" href="${escapeHtml(item.url)}">${escapeHtml(title)}</a>
            <button class="grova-cart__remove" type="button" aria-label="Remove ${escapeHtml(title)}" data-grova-cart-remove>&times;</button>
            ${variant ? `<p class="grova-cart__meta grova-cart__variant">${escapeHtml(variant)}</p>` : ''}
            ${sellingPlan ? `<p class="grova-cart__meta grova-cart__selling-plan">${escapeHtml(sellingPlan)}</p>` : ''}
            <div class="grova-cart__quantity" aria-label="Quantity">
              <button type="button" data-grova-cart-quantity="-1" aria-label="Decrease quantity">-</button>
              <span>${item.quantity}</span>
              <button type="button" data-grova-cart-quantity="1" aria-label="Increase quantity">+</button>
            </div>
            <div class="grova-cart__line-price">
              ${savings > 0 ? `<s>${formatMoney(original)}</s> ` : ''}
              <span>${formatMoney(displayedFinal)}</span>
              ${savings > 0 ? `<span class="grova-cart__line-saving">Save ${formatMoney(savings)}</span>` : ''}
            </div>
            ${bundleGiftMarkup(item)}
            ${isSubscriptionItem(item) ? supplySelectorMarkup(item, index) : subscriptionControlsMarkup(item, index)}
            ${subscriptionGiftsMarkup(item)}
          </article>
        `;
      })
      .join('');
  }

  function syncHeaderCount() {
    document.querySelectorAll('#cart-icon-bubble').forEach((cartLink) => {
      let bubble = cartLink.querySelector('.cart-count-bubble');

      if (!cart.item_count) {
        bubble?.remove();
        return;
      }

      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        cartLink.appendChild(bubble);
      }

      const visibleCount = bubble.querySelector('[aria-hidden="true"]');
      if (visibleCount) visibleCount.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
      const accessibleCount = bubble.querySelector('.visually-hidden');
      if (accessibleCount) accessibleCount.textContent = `${cart.item_count} items`;
    });

    document.querySelectorAll('.cart-bubble__text-count').forEach((el) => {
      el.textContent = cart.item_count ? String(cart.item_count) : '';
      el.classList.toggle('hidden', !cart.item_count);
    });

    document.querySelectorAll('.cart-bubble').forEach((el) => {
      el.classList.toggle('visually-hidden', !cart.item_count);
    });

    document.querySelectorAll('cart-icon').forEach((el) => {
      el.classList.toggle('header-actions__cart-icon--has-cart', Boolean(cart.item_count));
    });

    document.querySelectorAll('[data-instant-dynamic-content-source="CART_COUNT"]').forEach((el) => {
      el.textContent = String(cart.item_count || 0);
      el.hidden = !cart.item_count;
      el.classList.toggle('hidden', !cart.item_count);
      el.classList.toggle('is-hidden', !cart.item_count);
      el.setAttribute('aria-hidden', cart.item_count ? 'false' : 'true');
    });
  }

  function render() {
    const count = cart.item_count || 0;
    countEl.textContent = count ? String(count) : '';
    footer.hidden = !count;
    if (shippingSummary) shippingSummary.hidden = !count || !hasFreeShippingItems();
    updateShippingProgress(count);
    renderDiscountCodes();

    if (!count) {
      renderEmpty();
    } else {
      root.classList.remove('is-pending-add');
      renderItems();
      const originalTotal = cartOriginalTotal();
      const finalTotal = cart.total_price || 0;
      const savings = Math.max(originalTotal - finalTotal, 0);

      totalEl.textContent = formatMoney(finalTotal);
      if (checkoutTotalEl) checkoutTotalEl.textContent = formatMoney(finalTotal);
      originalTotalEl.hidden = !savings;
      originalTotalEl.textContent = savings ? formatMoney(originalTotal) : '';
      savingsBanner.hidden = !savings;
      savingsEl.textContent = savings ? `You're saving ${formatMoney(savings)} today!` : '';
    }

    syncHeaderCount();
  }

  function normalizeInstantCartLinks() {
    document.querySelectorAll('[data-instant-action-type="add-to-cart"][href]').forEach((link) => {
      const variantId = link.getAttribute('data-instant-action-variant-id');
      if (!variantId) return;

      const url = new URL(link.getAttribute('href'), window.location.origin);
      const currentQuantity = url.pathname.match(/\/cart\/\d+:(\d+)/)?.[1] || '1';
      const normalizedHref = `/cart/${variantId}:${currentQuantity}?storefront=true`;

      if (link.getAttribute('href') !== normalizedHref) {
        link.setAttribute('href', normalizedHref);
      }
    });
  }

  function instantFormForTrigger(trigger) {
    return trigger.closest('[data-instant-form-product-id], form[data-instant-type="root"], [data-instant-type="root"]');
  }

  function parseInstantQuantity(trigger) {
    try {
      const url = new URL(trigger.getAttribute('href') || '', window.location.origin);
      return Number(url.pathname.match(/\/cart\/\d+:(\d+)/)?.[1]) || 1;
    } catch (error) {
      return 1;
    }
  }

  function instantVariantIdForTrigger(trigger) {
    return (
      trigger.getAttribute('data-instant-action-variant-id') ||
      instantFormForTrigger(trigger)?.getAttribute('data-instant-form-variant-id') ||
      ''
    );
  }

  function normalizeSellingPlanId(value) {
    if (!value || value === 'one-time-purchase') return '';
    return value;
  }

  function instantSellingPlanIdForTrigger(trigger) {
    const directPlan = normalizeSellingPlanId(
      trigger.getAttribute('data-instant-action-selling-plan-id') ||
        trigger.getAttribute('data-selling-plan-id') ||
        trigger.getAttribute('selling-plan-id')
    );
    if (directPlan) return directPlan;

    const form = instantFormForTrigger(trigger);
    const activePlan = form?.querySelector(
      '[data-instant-action-type="select-selling-plan"][data-instant-state="active"], [data-instant-action-type="select-selling-plan"][aria-pressed="true"], [data-instant-action-type="select-selling-plan"].is-active'
    );
    const activePlanId = normalizeSellingPlanId(activePlan?.getAttribute('data-instant-selling-plan-id'));
    if (activePlanId || activePlan?.getAttribute('data-instant-selling-plan-id') === 'one-time-purchase') return activePlanId;

    return normalizeSellingPlanId(form?.getAttribute('data-instant-form-selling-plan-id'));
  }

  async function fetchLatestCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
    });
    return response.json();
  }

  function removedSubscriptionGiftVariantIds(cartData) {
    return new Set(
      String(cartData.attributes?.[removedSubscriptionGiftsAttribute] || '')
        .split(',')
        .map((variantId) => variantId.trim())
        .filter(Boolean)
    );
  }

  function desiredSubscriptionGiftQuantities(cartData) {
    const desired = new Map();
    const removedVariantIds = removedSubscriptionGiftVariantIds(cartData);
    const addQuantity = (key, quantity) => {
      if (removedVariantIds.has(String(subscriptionGifts[key].variantId))) return;
      desired.set(key, (desired.get(key) || 0) + quantity);
    };

    (cartData.items || []).forEach((item) => {
      if (!isSubscriptionItem(item) || isSubscriptionGift(item)) return;
      const option = subscriptionOptionForItem(item);
      const quantity = Math.max(0, Number(item.quantity) || 0);
      if (option?.key === '2' || option?.key === '3') addQuantity('journal', quantity);
      if (option?.key === '3') addQuantity('canister', quantity);
    });

    return desired;
  }

  async function setSubscriptionGiftRemoved(variantId, shouldRemove) {
    const normalizedVariantId = String(variantId);
    const removedVariantIds = removedSubscriptionGiftVariantIds(cart);
    if (shouldRemove) {
      removedVariantIds.add(normalizedVariantId);
    } else {
      removedVariantIds.delete(normalizedVariantId);
    }

    const updates = {};
    if (shouldRemove) {
      (cart.items || []).forEach((item) => {
        if (String(item.variant_id) === normalizedVariantId && isSubscriptionGift(item)) {
          updates[item.key] = 0;
        }
      });
    }

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates,
        attributes: {
          [removedSubscriptionGiftsAttribute]: [...removedVariantIds].join(','),
          [removedSubscriptionGiftsVersionAttribute]: removedSubscriptionGiftsVersion,
        },
      }),
    });
    if (!response.ok) throw new Error(`Unable to ${shouldRemove ? 'remove' : 'restore'} free gift`);

    cart = await response.json();
    cart = await syncSubscriptionGifts(cart);
    render();
    hydrateAndRender(cart);
  }

  function syncSubscriptionGifts(cartData) {
    if (giftSyncPromise) return giftSyncPromise;

    giftSyncPromise = (async () => {
      let nextCart = cartData;
      const removedVariantIds = removedSubscriptionGiftVariantIds(nextCart);
      const removalStateVersion = String(nextCart.attributes?.[removedSubscriptionGiftsVersionAttribute] || '');

      // Older carts can retain gift-removal attributes after every line is removed.
      // Clear that stale state once so a newly added subscription receives its gifts.
      if (removedVariantIds.size && removalStateVersion !== removedSubscriptionGiftsVersion) {
        const resetResponse = await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              [removedSubscriptionGiftsAttribute]: '',
              [removedSubscriptionGiftsVersionAttribute]: removedSubscriptionGiftsVersion,
            },
          }),
        });
        if (!resetResponse.ok) throw new Error('Unable to reset free gift preferences');
        nextCart = await resetResponse.json();
      }

      const desiredQuantities = desiredSubscriptionGiftQuantities(nextCart);
      const desiredByVariantId = new Map(
        [...desiredQuantities].map(([key, quantity]) => [String(subscriptionGifts[key].variantId), quantity])
      );
      const existingGiftItems = (nextCart.items || []).filter(isSubscriptionGift);
      const retainedVariantIds = new Set();
      const updates = {};

      existingGiftItems.forEach((item) => {
        const variantId = String(item.variant_id);
        const desiredQuantity = desiredByVariantId.get(variantId) || 0;
        const targetQuantity = desiredQuantity > 0 && !retainedVariantIds.has(variantId) ? desiredQuantity : 0;
        if (targetQuantity > 0) retainedVariantIds.add(variantId);
        if (Number(item.quantity) !== targetQuantity) updates[item.key] = targetQuantity;
      });

      if (Object.keys(updates).length) {
        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        });
        if (!updateResponse.ok) throw new Error('Unable to update free gifts');
        nextCart = await updateResponse.json();
      }

      const presentGiftVariantIds = new Set(
        (nextCart.items || []).filter(isSubscriptionGift).map((item) => String(item.variant_id))
      );
      const missingItems = [...desiredQuantities]
        .map(([key, quantity]) => ({ gift: subscriptionGifts[key], quantity }))
        .filter(({ gift }) => !presentGiftVariantIds.has(String(gift.variantId)))
        .map(({ gift, quantity }) => ({
          id: gift.variantId,
          quantity,
          properties: {
            _grova_free_gift: 'true',
            _grova_gift_source: 'subscription',
          },
        }));

      if (missingItems.length) {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: missingItems }),
        });
        if (!addResponse.ok) throw new Error('Unable to add free gifts');
        nextCart = await fetchLatestCart();
      }

      return nextCart;
    })().finally(() => {
      giftSyncPromise = null;
    });

    return giftSyncPromise;
  }

  function refreshCart() {
    if (refreshPromise) return refreshPromise;

    refreshPromise = (async () => {
      cart = await fetchLatestCart();
      cart = await syncSubscriptionGifts(cart);
      render();
      hydrateAndRender(cart);
      return cart;
    })().finally(() => {
      refreshPromise = null;
    });

    return refreshPromise;
  }

  async function changeLine(line, quantity, options = {}) {
    const hadDiscountCodes = appliedCodeDiscounts(cart).length > 0;
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ line, quantity }),
    });
    cart = await response.json();

    if (hadDiscountCodes && appliedCodeDiscounts(cart).length === 0 && cart.item_count > 0) {
      cart = await fetchLatestCart();
    }

    cart = await syncSubscriptionGifts(cart);

    if (options.render !== false) render();
    if (options.hydrate !== false) {
      const cartData = cart;
      hydrateVariantCompareAtPrices(cartData).then((changed) => {
        if (changed && cart === cartData && options.render !== false) render();
      });
    }
  }

  async function removeDiscountCode(code) {
    const remainingCodes = appliedCodeDiscounts(cart)
      .map((discount) => discount.title || discount.code)
      .filter((entry) => entry !== code);
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ discount: remainingCodes.join(',') }),
    });

    if (!response.ok) throw new Error('Unable to remove discount code');

    cart = await response.json();
    render();
    hydrateAndRender(cart);
  }

  async function addLine({ variantId, quantity, sellingPlanId }) {
    const item = {
      id: Number(variantId),
      quantity,
    };

    if (sellingPlanId) item.selling_plan = Number(sellingPlanId);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: [item] }),
    });

    if (!response.ok) throw new Error('Unable to add subscription option');
  }

  async function replaceLine(line, option, subscribe) {
    const item = cart.items?.[line - 1];
    if (!item || !option) return;

    updatingLine = line;
    updatingPlanKey = subscribe ? option.key : 'one-time';
    render();

    try {
      await changeLine(line, 0, { hydrate: false, render: false });
      await addLine({
        variantId: option.variantId,
        quantity: item.quantity,
        sellingPlanId: subscribe ? option.sellingPlanId : null,
      });
      await refreshCart();
    } finally {
      updatingLine = null;
      updatingPlanKey = null;
      render();
    }
  }

  function eventIsInsideCartDrawer(event) {
    return event.target instanceof Element && Boolean(event.target.closest('.grova-cart__drawer'));
  }

  function preventDesktopPageScroll(event) {
    if (!pageScrollLock?.isDesktop || eventIsInsideCartDrawer(event)) return;
    event.preventDefault();
  }

  function preventDesktopPageKeyScroll(event) {
    if (!pageScrollLock?.isDesktop || eventIsInsideCartDrawer(event)) return;
    if (
      event.target instanceof HTMLElement &&
      (event.target.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(event.target.tagName))
    ) {
      return;
    }

    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) {
      event.preventDefault();
    }
  }

  function lockPageScroll() {
    if (pageScrollLock) return;

    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    if (isDesktop) {
      // Do not change html/body styles on desktop. Those layout mutations cause
      // the sticky product carousel to recalculate and visibly jump.
      pageScrollLock = { isDesktop: true };
      document.addEventListener('wheel', preventDesktopPageScroll, { passive: false, capture: true });
      document.addEventListener('touchmove', preventDesktopPageScroll, { passive: false, capture: true });
      document.addEventListener('keydown', preventDesktopPageKeyScroll, true);
      return;
    }

    const doc = document.documentElement;
    const pageBody = document.body;
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    pageScrollLock = {
      isDesktop: false,
      scrollX,
      scrollY,
      docOverflow: doc.style.overflow,
      docOverscrollBehavior: doc.style.overscrollBehavior,
      docScrollBehavior: doc.style.scrollBehavior,
      bodyPosition: pageBody.style.position,
      bodyTop: pageBody.style.top,
      bodyLeft: pageBody.style.left,
      bodyRight: pageBody.style.right,
      bodyWidth: pageBody.style.width,
      bodyOverflow: pageBody.style.overflow,
      bodyOverscrollBehavior: pageBody.style.overscrollBehavior,
    };

    doc.classList.add('grova-cart-open');
    pageBody.classList.add('grova-cart-open');
    doc.style.overflow = 'hidden';
    doc.style.overscrollBehavior = 'none';
    pageBody.style.overflow = 'hidden';
    pageBody.style.overscrollBehavior = 'none';
    pageBody.style.position = 'fixed';
    pageBody.style.top = `-${scrollY}px`;
    pageBody.style.left = `-${scrollX}px`;
    pageBody.style.right = '0';
    pageBody.style.width = '100%';
  }

  function unlockPageScroll() {
    if (!pageScrollLock) return;

    const lock = pageScrollLock;
    pageScrollLock = null;

    if (lock.isDesktop) {
      document.removeEventListener('wheel', preventDesktopPageScroll, true);
      document.removeEventListener('touchmove', preventDesktopPageScroll, true);
      document.removeEventListener('keydown', preventDesktopPageKeyScroll, true);
      return;
    }

    const doc = document.documentElement;
    const pageBody = document.body;

    doc.classList.remove('grova-cart-open');
    pageBody.classList.remove('grova-cart-open');
    doc.style.overflow = lock.docOverflow;
    doc.style.overscrollBehavior = lock.docOverscrollBehavior;
    doc.style.scrollBehavior = 'auto';
    pageBody.style.position = lock.bodyPosition;
    pageBody.style.top = lock.bodyTop;
    pageBody.style.left = lock.bodyLeft;
    pageBody.style.right = lock.bodyRight;
    pageBody.style.width = lock.bodyWidth;
    pageBody.style.overflow = lock.bodyOverflow;
    pageBody.style.overscrollBehavior = lock.bodyOverscrollBehavior;

    window.scrollTo(lock.scrollX, lock.scrollY);
    requestAnimationFrame(() => {
      doc.style.scrollBehavior = lock.docScrollBehavior;
    });
  }

  function openCart() {
    clearTimeout(closeTimer);
    clearPreparedUnlockTimer();
    lockPageScroll();
    root.classList.remove('is-closing');
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    if (!window.matchMedia('(max-width: 480px)').matches) {
      root.querySelector('.grova-cart__drawer')?.focus({ preventScroll: true });
    }
  }

  function clearPreparedUnlockTimer() {
    if (!preparedUnlockTimer) return;
    clearTimeout(preparedUnlockTimer);
    preparedUnlockTimer = null;
  }

  function prepareCartOpen() {
    clearPreparedUnlockTimer();
  }

  function cancelPreparedCartOpen() {
    clearPreparedUnlockTimer();
    if (!root.classList.contains('is-open')) unlockPageScroll();
  }

  function closeCart() {
    if (!root.classList.contains('is-open')) return;

    clearTimeout(closeTimer);
    clearPreparedUnlockTimer();
    root.classList.remove('is-open');
    root.classList.add('is-closing');
    root.setAttribute('aria-hidden', 'true');
    closeTimer = setTimeout(() => {
      root.classList.remove('is-closing');
      unlockPageScroll();
    }, 200);
  }

  function refreshAndOpen() {
    openCart();
    return refreshCart();
  }

  function renderContents(parsedState) {
    if (!cart.item_count) renderPendingAdd();
    openCart();

    if (!Array.isArray(parsedState?.items)) return refreshCart();

    cart = parsedState;
    render();
    hydrateAndRender(cart);
    return refreshCart();
  }

  root.addEventListener('click', async (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('[data-grova-cart-close]')) {
      closeCart();
      return;
    }

    const removeDiscountButton = target.closest('[data-grova-cart-remove-discount]');
    if (removeDiscountButton) {
      removeDiscountButton.disabled = true;
      removeDiscountCode(removeDiscountButton.dataset.grovaCartRemoveDiscount).catch((error) => {
        removeDiscountButton.disabled = false;
        console.error(error);
      });
      return;
    }

    const toggleGiftButton = target.closest('[data-grova-cart-toggle-gift]');
    if (toggleGiftButton) {
      toggleGiftButton.disabled = true;
      toggleGiftButton.classList.add('is-loading');
      const shouldRemove = toggleGiftButton.dataset.grovaCartGiftRemoved !== 'true';
      setSubscriptionGiftRemoved(toggleGiftButton.dataset.grovaCartToggleGift, shouldRemove).catch((error) => {
        toggleGiftButton.disabled = false;
        toggleGiftButton.classList.remove('is-loading');
        console.error(error);
      });
      return;
    }

    const item = target.closest('[data-line]');
    if (!item) return;

    const line = Number(item.dataset.line);
    const current = cart.items?.[line - 1]?.quantity || 0;

    if (target.closest('[data-grova-cart-remove]')) {
      changeLine(line, 0);
      return;
    }

    const subscribeButton = target.closest('[data-grova-cart-subscribe]');
    if (subscribeButton) {
      const option = subscriptionOptionForItem(cart.items?.[line - 1]);
      replaceLine(line, option, true);
      return;
    }

    if (target.closest('[data-grova-cart-one-time]')) {
      const option = subscriptionOptionForItem(cart.items?.[line - 1]);
      replaceLine(line, option, false);
      return;
    }

    const planButton = target.closest('[data-grova-cart-plan]');
    if (planButton) {
      const option = editableSubscriptionOptions.find((entry) => entry.key === planButton.dataset.grovaCartPlan);
      const currentPlanId = cart.items?.[line - 1]?.selling_plan_allocation?.selling_plan?.id;
      if (String(currentPlanId) === String(option?.sellingPlanId)) return;
      replaceLine(line, option, true);
      return;
    }

    const quantityButton = target.closest('[data-grova-cart-quantity]');
    if (quantityButton) {
      const delta = Number(quantityButton.dataset.grovaCartQuantity);
      const quantityControl = quantityButton.closest('.grova-cart__quantity');
      quantityControl?.classList.add('is-loading');
      quantityControl?.setAttribute('aria-busy', 'true');
      quantityControl?.querySelectorAll('button').forEach((button) => {
        button.disabled = true;
      });

      try {
        await changeLine(line, Math.max(current + delta, 0));
      } catch (error) {
        quantityControl?.classList.remove('is-loading');
        quantityControl?.removeAttribute('aria-busy');
        quantityControl?.querySelectorAll('button').forEach((button) => {
          button.disabled = false;
        });
        console.error(error);
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!root.classList.contains('is-open')) return;
    if (isOptiMonkEvent(event)) return;
    if (event.key === 'Escape') {
      closeCart();
      return;
    }

    if (event.target instanceof Element && event.target.closest('.grova-cart__drawer')) return;
    if (['ArrowDown', 'ArrowUp', 'End', 'Home', 'PageDown', 'PageUp', ' '].includes(event.key)) {
      event.preventDefault();
    }
  });

  document.addEventListener('touchstart', (event) => {
    if (!root.classList.contains('is-open')) return;
    touchStartY = event.touches[0]?.clientY || 0;
  }, { passive: true });

  document.addEventListener('touchmove', (event) => {
    if (!root.classList.contains('is-open')) return;
    if (isOptiMonkEvent(event)) return;
    if (!(event.target instanceof Element)) return;

    const scrollArea = event.target.closest('.grova-cart__body');
    if (!scrollArea) {
      event.preventDefault();
      return;
    }

    const currentY = event.touches[0]?.clientY || 0;
    const pullingDownAtTop = currentY > touchStartY && scrollArea.scrollTop <= 0;
    const pushingUpAtBottom =
      currentY < touchStartY && scrollArea.scrollTop + scrollArea.clientHeight >= scrollArea.scrollHeight - 1;

    if (pullingDownAtTop || pushingUpAtBottom) event.preventDefault();
  }, { passive: false });

  document.addEventListener('wheel', (event) => {
    if (!root.classList.contains('is-open')) return;
    if (isOptiMonkEvent(event)) return;

    const scrollArea =
      event.target instanceof Element ? event.target.closest('.grova-cart__body') : null;

    if (!scrollArea) {
      event.preventDefault();
      return;
    }

    const scrollingPastTop = event.deltaY < 0 && scrollArea.scrollTop <= 0;
    const scrollingPastBottom =
      event.deltaY > 0 &&
      scrollArea.scrollTop + scrollArea.clientHeight >= scrollArea.scrollHeight - 1;

    if (scrollingPastTop || scrollingPastBottom) event.preventDefault();
  }, { passive: false });

  document.addEventListener(
    'click',
    (event) => {
      if (!root.classList.contains('is-open')) return;
      if (isOptiMonkEvent(event)) return;
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('.grova-cart__drawer')) return;
      closeCart();
    },
    true
  );

  normalizeInstantCartLinks();

  let instantLinkObserverTimer;
  const scheduleInstantLinkNormalization = () => {
    clearTimeout(instantLinkObserverTimer);
    instantLinkObserverTimer = setTimeout(normalizeInstantCartLinks, 50);
  };

  const instantLinkObserver = new MutationObserver(scheduleInstantLinkNormalization);
  instantLinkObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener(
    'click',
    async (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const trigger = target.closest('[data-instant-action-type="add-to-cart"]');
      if (!trigger || root.contains(trigger)) return;

      const variantId = instantVariantIdForTrigger(trigger);
      if (!variantId) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const sellingPlanId = instantSellingPlanIdForTrigger(trigger);
      trigger.setAttribute('aria-busy', 'true');

      try {
        if (!cart.item_count) renderPendingAdd();
        openCart();
        await addLine({
          variantId,
          quantity: parseInstantQuantity(trigger),
          sellingPlanId,
        });
        document.dispatchEvent(
          new CustomEvent('instant:add-to-cart', {
            detail: { variantId, sellingPlanId },
          })
        );
      } catch (error) {
        console.error(error);
      } finally {
        trigger.removeAttribute('aria-busy');
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const trigger = target.closest(
        '[data-grova-cart-trigger], a[href="/cart"], a[href*="/cart"], button[data-testid="cart-drawer-trigger"], [data-instant-action-type*="cart"]'
      );

      if (!trigger || root.contains(trigger)) return;

      const href = trigger.getAttribute('href') || '';
      const actionType = trigger.getAttribute('data-instant-action-type') || '';
      if (actionType === 'add-to-cart') return;

      const isCartTrigger =
        trigger.hasAttribute('data-grova-cart-trigger') ||
        actionType.includes('cart') ||
        href === '/cart' ||
        href.endsWith('/cart') ||
        href.includes('/cart?');

      if (!isCartTrigger) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      refreshAndOpen();
    },
    true
  );

  document.addEventListener('instant:add-to-cart', (event) => {
    event.stopPropagation();
    event.stopImmediatePropagation();
    refreshAndOpen();
  }, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form?.matches('.gnp-bundle-grid form, [data-grova-cart-form]')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const formData = new FormData(form);
    const submitButton = form.querySelector('[type="submit"]');
    const originalButtonHtml = submitButton?.innerHTML || 'ADD TO CART';
    const isBundleSaveButton = submitButton?.classList.contains('gbs-add');
    let dotCount = 1;
    const loadingTimer = submitButton && !isBundleSaveButton ? window.setInterval(() => {
      dotCount = dotCount === 3 ? 1 : dotCount + 1;
      submitButton.textContent = `Adding${'.'.repeat(dotCount)}`;
    }, 320) : null;
    if (isBundleSaveButton) {
      submitButton.classList.add('loading');
    } else if (submitButton) {
      submitButton.textContent = 'Adding.';
    }
    submitButton?.setAttribute('aria-busy', 'true');
    if (submitButton) submitButton.disabled = true;

    try {
      await addLine({
        variantId: formData.get('id'),
        quantity: Number(formData.get('quantity') || 1),
      });
      await refreshCart();
      openCart();
    } catch (error) {
      console.error(error);
    } finally {
      if (loadingTimer) window.clearInterval(loadingTimer);
      if (submitButton) {
        submitButton.innerHTML = originalButtonHtml;
        submitButton.classList.remove('loading');
      }
      submitButton?.removeAttribute('aria-busy');
      if (submitButton) submitButton.disabled = false;
    }
  }, true);

  ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxProduct:added', 'ajaxProduct:updated'].forEach((eventName) => {
    document.addEventListener(eventName, refreshCart);
  });

  window.openCartDrawer = refreshAndOpen;
  window.prepareCartDrawerOpen = prepareCartOpen;
  window.cancelPreparedCartDrawerOpen = cancelPreparedCartOpen;
  window.GROVA_CART_DRAWER = {
    open: refreshAndOpen,
    close: closeCart,
    refresh: refreshCart,
    prepare: prepareCartOpen,
    cancelPrepare: cancelPreparedCartOpen,
  };

  root.open = refreshAndOpen;
  root.close = closeCart;
  root.renderContents = renderContents;
  root.getSectionsToRender = () => [{ id: 'cart-icon-bubble' }];
  root.setActiveElement = (element) => {
    root.activeElement = element;
  };

  render();
  hydrateAndRender(cart);
  } catch (error) {
    delete root.dataset.grovaCartInitialized;
    document.documentElement.dataset.grovaCartError = String(error?.message || error);
    console.error('[Grova cart drawer]', error);
  }
})();
